import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { indicatorState } from "../../stores/atoms";
import { Link, useHistory } from "react-router-dom";
import { awsInstance } from "../../actions/api";
import ModalForCallNumber from "../modal/ModalForCallNumber";
import { thousandFormat } from "../../actions/utiles";
import Loading from "./../Loading";

function Dashboard() {
  const [, setIndicator] = useRecoilState(indicatorState);
  const [modalShow, setModalShow] = useState(false);
  const [dashboard, setDashboard] = useState("");
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const history = useHistory();

  useEffect(() => {
    if (user !== null && !user["call_number"]) {
      setModalShow(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    setIndicator("홈");

    getDashboardInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDashboardInfo = async () => {
    try {
      const { data } = await awsInstance.get("/business/dashboard", {
        params: {
          id: user.company_id,
        },
      });
      if (data.code === "SUCCESS") {
        setDashboard(data.data);
      } else {
        alert(data.message);
      }
    } catch (e) {
      alert(e);
    }
  };

  const onAlertReady = () => {
    alert("서비스 준비 중입니다.");
  };

  const onServiceClick = async (service) => {
    try {
      setLoading(true);
      let body = {
        company_id: user.company_id,
        type: service.service,
      };
      const { data } = await awsInstance.post("/business/service-ban-list", body);
      if (data.code === "SUCCESS") {
        getDashboardInfo();
      } else {
        alert(data.message);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  }

  const onHandleClick = () => {
    window.open('./고요한_비즈니스_서비스_소개서.pdf');
  }

  return (
    <div className="dashboard">
      <h5>대시보드</h5>
      <table className="table txt-dark-gray">
        <thead className="txt-initial">
          <tr>
            <th colSpan="3" className="font-bolder">
              고요한M 이용내역{" "}
              <Link to="/use-history">
                <span className="float-right txt-dark-gray font-normal">
                  상세보기
                  <i className="fas fa-chevron-right ml-1 txt-dark-gray font-bold align-middle" />
                </span>
              </Link>
            </th>
            <th colSpan="2" className="width-30 font-bolder">
              현황
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th rowSpan="1" colSpan="1" className="font-bolder">
              월별
            </th>
            <th rowSpan="1" colSpan="1" className="font-bolder">
              전월
            </th>
            <th rowSpan="1" colSpan="1" className="font-bolder">
              당월
            </th>
            <th className="txt-gray txt-initial font-bolder" rowSpan="2">
              카드
              <p className="txt-dark-gray font-bold txt-right">
                {dashboard.count_card}개
              </p>
            </th>
            <th className="txt-gray txt-initial font-bolder" rowSpan="2">
              연계고용제도
              <p className="txt-dark-gray font-bold txt-right">
                {dashboard.use_system === 0 ? "미사용" : "사용"}
              </p>
            </th>
          </tr>
          <tr>
            <th rowSpan="2" colSpan="1" className="font-bolder">
              이용건수
            </th>
            <td rowSpan="2">
              <span className="font-bold">
                {dashboard.prev_count_history}회
              </span>
            </td>
            <td rowSpan="2">
              <span className="font-bold">{dashboard.count_history}회</span>
            </td>
          </tr>
          <tr>
            <th className="txt-gray txt-initial font-bolder" rowSpan="3">
              관리자
              <p className="txt-dark-gray font-bold txt-right">
                {dashboard.count_admin}명
              </p>
            </th>
            <th className="txt-gray txt-initial font-bolder" rowSpan="3">
              직원
              <p className="txt-dark-gray font-bold txt-right">
                {dashboard.count_employee}명
              </p>
            </th>
          </tr>
          <tr>
            <th rowSpan="2" colSpan="1" className="font-bolder">
              이용금액
            </th>
            <td rowSpan="2">
              <span className="font-bold">
                {thousandFormat(dashboard.prev_sum_fare)}원
              </span>
            </td>
            <td rowSpan="2">
              <span className="font-bold">
                {thousandFormat(dashboard.sum_fare)}원
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      {(user.authorized === 1 || user.authorized === 2) && <div className="table display-flex justify-content-between" style={{ height: 'auto' }}>
        <table className="table width-30">
          <thead>
            <tr>
              <td>
                <div className="display-flex align-items-center justify-content-center">
                  <button
                    className="btn-outline-white"
                    onClick={() => history.push("/employee-register")}
                    >
                    <img
                      className="employee-img mb-1"
                      src="/employee.png"
                      width="70px"
                      height="70px"
                      alt="employee"
                      />
                    <p className="m-0 txt-dark-gray font-bolder">직원 등록</p>
                  </button>
                </div>
              </td>
              <td>
                <div className="display-flex align-items-center justify-content-center">
                  <button
                    className="btn-outline-white"
                    onClick={() => setModalShow(true)}
                  >
                    <img
                      className="call-number-img mb-1"
                      src="/call_number.png"
                      width="70px"
                      height="70px"
                      alt="call-number"
                    />
                    <p className="m-0 txt-dark-gray font-bolder">호출번호 설정</p>
                  </button>
                </div>
              </td>
            </tr>
          </thead>
        </table>

        <table className="table width-20">
          <thead>
            <tr>
              <th className="txt-initial font-bolder" rowSpan="2" style={{ verticalAlign: 'top' }}>
                <span className="font-bolder">서비스</span>
                {dashboard.service_list != null && dashboard.service_list.map((service, index) => (
                  <div 
                    key={index} 
                    className="txt-dark-gray font-bold mt-1"
                    >
                    {service.service_in_korean} {service.is_available ? '사용 중' : '미사용 중'}
                    <button 
                      className="btn-blue float-right"
                      onClick={() => onServiceClick(service)}
                      >
                      {service.is_available ? '미사용' : '사용'}
                    </button>
                  </div>
                ))}
              </th>
            </tr>
          </thead>
        </table>
      </div>}
      
      <table className="table table-download">
        <thead>
          <tr>
            <td colSpan="3">사용법 및 소개서 등 다운로드 하기</td>
            <td className="cursor" onClick={onHandleClick}>소개서 보기</td>
            <td onClick={onAlertReady}>
              관리자
              <br /> 이용가이드
            </td>
            <td onClick={onAlertReady}>
              직원 <br /> 이용가이드
            </td>
          </tr>
        </thead>
      </table>

      <ModalForCallNumber show={modalShow} onHide={() => setModalShow(false)} />
    </div>
  );
}

export default Dashboard;
